import { useCallback, useState } from 'react';

export function useImageInsertTarget<T>() {
  const [target, setTarget] = useState<T | null>(null);

  const openTarget = useCallback((nextTarget: T) => {
    setTarget(nextTarget);
  }, []);

  const clearTarget = useCallback(() => {
    setTarget(null);
  }, []);

  return {
    target,
    isOpen: target !== null,
    openTarget,
    clearTarget,
  };
}
